export default __webpack_public_path__ + "static/media/investment_card_3@3x.0407754d.png";